import React from "react";
import { Field, Form } from "react-final-form";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  charityForgotPassword,
  strategicForgotPassword,
} from "../../actions/auth";
import { renderField } from "../../components/forms";
import { toAbsoluteUrl } from "../../utils";
import "./ForgotPassword.scss";
import { forgetPasswordValidation as validate } from "../../components/validations/signIn";
import { toast } from "react-toastify";

const ForgotPassword = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (value) => {
    const data = {
      email: value.email,
    };
    if (props.isStrategic) {
      dispatch(strategicForgotPassword(data))
        .then((res) => {
          navigate("/strategic_signin");
          toast.success(res.message);
        })
        .catch((res) => toast.error(res.message));
    } else {
      dispatch(charityForgotPassword(data))
        .then((res) => {
          navigate("/signin");
          toast.success(res.message);
        })
        .catch((res) => toast.error(res.message));
    }
  };

  return (
    <>
      <section className="section-div forgot-section">
        <div className="d-flex align-items-center min-h100">
          <div className="col-6 none-mobile">
            <div>
              <figure className="text-center figure-img">
              {!props.isStrategic ? <img
                  // src={toAbsoluteUrl("/images/login-left.svg")}
                  src={toAbsoluteUrl("/images/Nonprofit SignIn.png")}
                  alt="left-img"
                /> : <img
                  // src={toAbsoluteUrl("/images/login-left.svg")}
                  src={toAbsoluteUrl("/images/giving partner signIn.png")}
                  alt="left-img"
                />}
              </figure>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <Form onSubmit={onSubmit} validate={validate}>
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="form-box">
                  <figure className="mainLogo">
                    <img src={toAbsoluteUrl("/images/logo.svg")} alt="logo" />
                  </figure>
                  <span className="signHeader">Rosi Giving</span>
                  <ul className="input-list">
                    <li>
                      <label
                        className="label-text"
                        style={{ marginBottom: "5px", display: "block" }}
                      >
                        Forgot Password
                      </label>
                      <Field
                        name="email"
                        type="text"
                        placeholder="Enter Email"
                        component={renderField}
                        className="form-grp username"
                        inputclass="input-box"
                      />
                    </li>
                  </ul>
                  <div>
                    <button type="submit" className="link-btn">
                      Reset Password
                    </button>
                    <span className="bottom-text">
                      <Link
                        to={props.isStrategic ? "/strategic_signin" : "/signin"}
                      >
                        Login
                      </Link>
                    </span>
                  </div>
                </form>
              )}
            </Form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgotPassword;
